import type { Resource } from '../../';
export const country_countries_DE: Resource = {"default":"Germany"};
